import { type Role, createApiPagedResponseSchema } from '@/models';
import { RoleSchema } from '@/models/Role.ts';
import { req } from '@/req/req.ts';

export async function list(): Promise<Role[]> {
  return await req
    .get('/api/user/role', {
      zodSchema: createApiPagedResponseSchema(RoleSchema),
    })
    .then((res) => res.data.data);
}

export async function getUserPermissions(userId: string) {
  return await req
    .get(`/api/user/uis/by-user/${userId}`)
    .then((res) => res.data.data);
}

export function useUserPermissions(userId: string) {
  return useQuery({
    queryKey: ['userPermissions', userId],
    queryFn: () => getUserPermissions(userId),
  });
}
